<template>
  <div class="error-page">
    <div class="error-code">
      <img
        src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif"
        alt="404"
      />
    </div>
    <div class="error-desc">
      <div class="error-desc-item">
        <div class="error-desc-item-title">抱歉，页面不存在</div>
        <div class="error-desc-item-desc">
          请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告
        </div>
        <div class="error-desc-item-actions">
          <el-button type="primary" size="large" @click="back">
            返回首页
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page404",
  methods: {
    back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: "/dashboard" });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 500px;
  max-width: 1200px;
  margin: 0 auto;

  .error-code {
    width: 300px;

    img {
      width: 100%;
    }
  }

  .error-desc {
    padding-left: 60px;

    &-item {
      &-title {
        font-size: 24px;
        color: #1f2329;
        line-height: 32px;
        margin-bottom: 16px;
      }

      &-desc {
        font-size: 14px;
        color: #646a73;
        line-height: 22px;
        margin-bottom: 24px;
      }

      &-actions {
        .el-button {
          margin-right: 12px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .error-page {
    flex-direction: column;
    padding: 30px 20px;

    .error-code {
      width: 200px;
      margin-bottom: 30px;
    }

    .error-desc {
      padding-left: 0;
      text-align: center;
    }
  }
}
</style>
